"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = reduceError;

function reduceError(err) {
  return function (e) {
    return e.length < 2 ? e[0] || null : e;
  }((err || []).filter(Boolean));
}